export default __webpack_public_path__ + "static/careers-benefits-block1-icon07.url-fff720f460cf3d54fa38a6bacc0233bc.svg";